module.exports = __webpack_public_path__ + "static/media/img_3-10a.28aa670b.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/c-5/img_3-10a.png
// module id = 663
// module chunks = 0